<template>
    <div class="custom-file">
        <!-- <input @input="$emit('update:modelValue', $event.target.files[0]); fileValue = $event.target.files[0]" type="file" class="custom-file-input" name="file[]"> -->
        <template v-if="multiple === false">
            <input
                ref="input_file_ref"
                type="file"
                class="custom-file-input"
                name="file[]"
                :accept="accept"
                @input="fileValue = []"
                @change="fileValue = $event.target.files; $emit('update:modelValue', $event.target.files);"
            />
            <!-- @input="$emit('input')" -->
            <!-- @change="fileValue = $event.target.files; $emit('change', $event.target.files[0])" -->
            <!-- @change="onChange($event)" -->
            <label class="custom-file-label" :class="fileValue.length ? 'bg-light text-dark fw-bold' : '' " v-html="fileValue[0] ? fileValue[0].name : placeholder"></label>
            <div v-if="fileSizeError" v-html="fslError"></div>
        </template>

        <template v-else-if="multiple === true">
            <!-- <input @input="fileValue = $event.target.files;" type="file" class="custom-file-input" name="file[]" multiple accept=".pdf,.txt" /> -->
            <input
                ref="input_file_ref"
                type="file"
                class="custom-file-input"
                name="file[]"
                multiple :accept="accept"
                @input="fileValue = []"
                @change="fileValue = $event.target.files; $emit('update:modelValue', $event.target.files);"
            />
            <!-- @change="onChange($event)" -->
            <label class="custom-file-label" :class="fileValue.length ? 'bg-light text-dark fw-bold' : '' " v-html="fileValue.length ? `Fayl sayı: ${fileValue.length}` : placeholder"></label>
            <div v-if="!fileSizeError && fileValue.length" class="border py-2 px-1 m-0 row">
                <template v-for="(item, index) in fileValue" :key="index" >
                    <div class="col-12 col-sm-9">
                        <label class="mb-1">
                            {{ index+1 }}. {{ item.name }}
                        </label>
                    </div>
                    <div class="col-12 col-sm-3 text-end">
                        {{ item.size > 1048576 ? (item.size/1048576).toFixed(2) + ' MB' : (item.size/1024).toFixed(2) + ' kB' }}
                    </div>
                </template>
            </div>
            <div v-else-if="fileSizeError" v-html="fslError"></div>
        </template>
    </div>
</template>

<script>
import {ref, watchEffect} from 'vue';

export default {
    name: "InputFile",
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        input_file_ref: {
            type: Object,
            default: () => {
                return null;
            },
        },
        accept: {
            type: String,
            default: 'application/pdf',
        },
        maxSize: {
            type: Number,
            default: 3000000,
        },
        sizeErrorLabel: {
            type: String,
            default: 'Files size error ! Max:',
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const fileValue = ref([]);
        const fileSizeError = ref(false);
        const fslError = ref(props.placeholder);

        // const fileChange = () => {
        //     context.emit('update:modelValue', fileValue.value);
        // };

        // const onChange = (event) => {
        //     fileValue.value = event.target.files;
        //     fileChange();
        // };

        var a = 0;
        watchEffect(() => {
            let b = fileValue.value;
            for(let i=0; i < b.length; i++){
                let e = b[i];
                a += e.size;
            }
            fileSizeError.value = a > props.maxSize ? true : false;
            a = 0;
            if( fileSizeError.value ){
                fileValue.value = [];
                fslError.value = `<span class="text-danger small">${props.sizeErrorLabel} ${(props.maxSize/1048576).toFixed(2)} MB</span>`;
            }
        });

        const clear = () => {
            fileValue.value = [];
        };

        return {
            fileValue,
            fileSizeError,
            fslError,
            clear,
            // onChange,
        };
    },
}
</script>


<style lang="scss">
    .custom-file {
        position: relative;
        display: inline-block;
        width: 100%;
        // height: calc(2rem + 2px);
        margin-bottom: 0;

        .custom-file-input {
            position: relative;
            z-index: 2;
            width: 100%;
            height: calc(2rem + 2px);
            margin: 0;
            overflow: hidden;
            opacity: 0;
            // padding: 0.4rem;
            cursor: pointer;
        }
        .custom-file-label {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            z-index: 1;
            cursor: pointer;

            // height: calc(2rem + 2px);
            // padding: .5rem;
            // overflow: hidden;
            // font-weight: 400;
            // line-height: 1.8;

            height: calc(2rem + 2px);
            padding: 0.5rem;
            overflow: hidden;
            font-weight: 400;
            line-height: 1.2;

            color: #495057;
            background-color: #ffffff13;
            // background-color: transparent;
            border: 1px solid #ced4da;
            border-top-color: rgb(206, 212, 218);
            border-right-color: rgb(206, 212, 218);
            border-bottom-color: rgb(206, 212, 218);
            border-left-color: rgb(206, 212, 218);
            border-radius: .25rem;
        }
        .custom-file-label::after {
            content: '...';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 3;
            display: block;
            // height: calc(1.5em + .75rem);
            padding: .4rem .75rem;
            line-height: 1.5;
            color: #495057;
            background-color: var(--bs-primary);
            color: var(--bs-white);
            border-left: inherit;
            border-left-color: inherit;
            border-radius: 0 .25rem .25rem 0;
        }
    }
</style>
